import React from "react";
import { useDispatch } from "react-redux";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Typography } from "@mui/material";
import {
  CancelButton,
  DeleteButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { deletAssignedKra } from "../../../../../redux/features/appraisalSlice";
import { useSnackbar } from "notistack";

const DeleteKra = ({
  open,
  setOpen,
  setKraApiGetCallAfterTrigger,
  selectedKraId,
  setSelectedKraId,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const handleDelete = () => {
    const dataModel = [selectedKraId];
    dispatch(deletAssignedKra(dataModel)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        setKraApiGetCallAfterTrigger((prev) => !prev);
        setOpen(false);
        setSelectedKraId(null);
      } else {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
      }
    });
  };
  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title="Delete KRA"
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      content={
        <>
          <Box>
            <Typography>
              Are you sure? you want to delete this KRA..!
            </Typography>
          </Box>
        </>
      }
      actionButton={
        <>
          <CancelButton size={"small"} action={() => setOpen(false)}>
            Cancel
          </CancelButton>
          <DeleteButton action={handleDelete} size={"small"}>
            Delete
          </DeleteButton>
        </>
      }
    />
  );
};
export default DeleteKra;
